export const endpoints = {
  BUG_REPORTS: '/api/bug-reports',
  BUG_REPORT_BY_ID: '/api/bug-reports/:id',
};
